var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticClass:"text-primary-500 pointer icon-copy",class:_vm.className,attrs:{"size":"18"},on:{"click":_vm.handleCopy}},'v-icon',attrs,false),on),[_vm._v(_vm._s(_vm.iconName))])]}}])},[_c('span',[_vm._v("Copy")])])}
var staticRenderFns = []

export { render, staticRenderFns }